import React from 'react';

const Navbar = () => (
  <nav className="navbar">
    <div className="logo">AiLogify</div>
    <div className="nav-links">
      <a href="#features">Features</a>
      <a href="#demo">Request Demo</a>
    </div>
  </nav>
);

export default Navbar;